import type { PropsWithChildren } from 'react';

import { inter } from '@/shared/config';

import { InterviewHeader } from './interview-header';

export function CandidateLayoutShell({
	children,
	showHeader,
}: PropsWithChildren<{ showHeader: boolean }>) {
	if (showHeader)
		return (
			<InterviewHeader>
				<div className="flex h-full w-full flex-col bg-gray-5">{children}</div>
			</InterviewHeader>
		);
	return (
		<div
			className={`${inter.className} relative flex h-[100svh] w-full flex-col overflow-hidden bg-gray-5`}
		>
			{children}
		</div>
	);
}
